module.exports = __webpack_public_path__ + "img/huodong_mini1.f563a676.jpg";